import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class SuspiciousLoginConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getRequestPinEndpoint(): string {
		return this.configService.get(
			(x) => x.core.suspiciousLogin.endpoints!.requestPin,
			"v1/authenticationchallenges"
		);
	}

	getExternalEventEnabled(): boolean {
		return this.configService.get((x) => x.core.suspiciousLogin.externalEventEnabled, false);
	}
}
